__turbopack_context__.v({
  "MuiListItemTextRoot": "product-module-scss-module__ayD5hq__MuiListItemTextRoot",
  "about-product": "product-module-scss-module__ayD5hq__about-product",
  "add-to-cart": "product-module-scss-module__ayD5hq__add-to-cart",
  "add-to-cart-disabled": "product-module-scss-module__ayD5hq__add-to-cart-disabled",
  "additional-info": "product-module-scss-module__ayD5hq__additional-info",
  "additional-info__accordion": "product-module-scss-module__ayD5hq__additional-info__accordion",
  "alt-img__list": "product-module-scss-module__ayD5hq__alt-img__list",
  "alt-img__list--item": "product-module-scss-module__ayD5hq__alt-img__list--item",
  "bestSeller-icon": "product-module-scss-module__ayD5hq__bestSeller-icon",
  "bottomCenterText": "product-module-scss-module__ayD5hq__bottomCenterText",
  "breadcrumbWrap": "product-module-scss-module__ayD5hq__breadcrumbWrap",
  "button-01": "product-module-scss-module__ayD5hq__button-01",
  "button-02": "product-module-scss-module__ayD5hq__button-02",
  "button-3d": "product-module-scss-module__ayD5hq__button-3d",
  "degreeCircle": "product-module-scss-module__ayD5hq__degreeCircle",
  "delivery-info": "product-module-scss-module__ayD5hq__delivery-info",
  "design-item": "product-module-scss-module__ayD5hq__design-item",
  "details-section": "product-module-scss-module__ayD5hq__details-section",
  "fa": "product-module-scss-module__ayD5hq__fa",
  "isSticky": "product-module-scss-module__ayD5hq__isSticky",
  "leftSection": "product-module-scss-module__ayD5hq__leftSection",
  "option": "product-module-scss-module__ayD5hq__option",
  "option-wrapper": "product-module-scss-module__ayD5hq__option-wrapper",
  "pLarge": "product-module-scss-module__ayD5hq__pLarge",
  "price": "product-module-scss-module__ayD5hq__price",
  "product-image__section": "product-module-scss-module__ayD5hq__product-image__section",
  "product-image__section--wrapper": "product-module-scss-module__ayD5hq__product-image__section--wrapper",
  "productDetails": "product-module-scss-module__ayD5hq__productDetails",
  "product_desc_collapsed": "product-module-scss-module__ayD5hq__product_desc_collapsed",
  "qty-btn": "product-module-scss-module__ayD5hq__qty-btn",
  "qty-input": "product-module-scss-module__ayD5hq__qty-input",
  "ratingSection": "product-module-scss-module__ayD5hq__ratingSection",
  "ratingStars": "product-module-scss-module__ayD5hq__ratingStars",
  "rightCont": "product-module-scss-module__ayD5hq__rightCont",
  "selected": "product-module-scss-module__ayD5hq__selected",
  "show_more": "product-module-scss-module__ayD5hq__show_more",
  "star": "product-module-scss-module__ayD5hq__star",
  "starCircle": "product-module-scss-module__ayD5hq__starCircle",
  "toggle-info": "product-module-scss-module__ayD5hq__toggle-info",
  "type-qty": "product-module-scss-module__ayD5hq__type-qty",
});
